/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.big-card-container {
  @apply flex-wrap ;
}

.big-card-wrapper {
  @apply w-full;
}

.big-card-wrapper.two-wide {
  @apply grid grid-cols-1 sm:grid-cols-2 gap-32px;
}

.big-card-wrapper.one-wide {
  @apply flex flex-col gap-32px;
}

.big-card {
  @apply flex flex-col justify-start text-start rounded-xl p-40px gap-64px relative z-10 w-full  font-poppins;
}

.big-card.one-wide {
  @apply flex-col md:flex-row;
}

.big-card.one-wide .big-card-image.square {
  @apply max-w-[500px] lg:max-w-[700px];
}

.two-wide .big-card-background {
  @apply h-5/6  w-full rounded-xl absolute bottom-0 left-0 -z-10 bg-ui-gray-6;
}

.two-wide.icon-size .big-card-background {
  @apply h-full  w-full rounded-xl absolute bottom-0 left-0 -z-10 bg-ui-gray-6;
}

.one-wide .big-card-background {
  @apply h-5/6 sm:h-full w-full md:w-[90%] rounded-xl absolute bottom-0 right-0 -z-10 bg-ui-gray-6;
}
.one-wide.icon-size .big-card-background {
  @apply h-5/6 sm:h-full w-full rounded-xl absolute bottom-0 right-0 -z-10 bg-ui-gray-6;
}

.big-card.none .big-card-background {
  @apply w-full h-full;
}

.big-card-content {
  @apply max-w-[500px] lg:max-w-none gap-12px flex flex-col justify-center;
}

.big-card-description {
  @apply fs-min text-ui-gray-2 font-normal;
}

.big-card-description p {
  @apply mb-12px;
}

.big-card-read-more {
  @apply text-ui-gray-2 hover:font-semibold font-normal transition-all;
}

.big-card-image {
  @apply w-full h-auto object-cover rounded-xl overflow-hidden;
}

.big-card-image.square {
  @apply aspect-square max-w-[200px];
}

.big-card-image.wide {
  @apply aspect-video max-w-[600px] md:max-w-none;
}

.big-card-image.icon-size {
  @apply aspect-square max-w-[100px] h-full;
}

.big-card-image.none {
  @apply hidden;
}

/* Animation fadeIn */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2, .overlay3, .overlay4, .overlay5, .overlay6, .overlay7, .overlay8, .overlay9, .overlay10, .overlay11, .overlay12{
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.big-card-wrapper.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
.big-card-wrapper.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

.big-card-wrapper.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: 0.3s;
}

.big-card-wrapper.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: 0.45s;
}

.big-card-wrapper.animate .overlay5 {
  animation-name: fade-in;
  animation-delay: 0.6s;
}

.big-card-wrapper.animate .overlay6 {
  animation-name: fade-in;
  animation-delay: 0.75s;
}

.big-card-wrapper.animate .overlay7 {
  animation-name: fade-in;
  animation-delay: 0.9s;
}

.big-card-wrapper.animate .overlay8 {
  animation-name: fade-in;
  animation-delay: 1.05s;
}

.big-card-wrapper.animate .overlay9 {
  animation-name: fade-in;
  animation-delay: 1.2s;
}

.big-card-wrapper.animate .overlay10 {
  animation-name: fade-in;
  animation-delay: 1.35s;
}

.big-card-wrapper.animate .overlay11 {
  animation-name: fade-in;
  animation-delay: 1.5s;
}

.big-card-wrapper.animate .overlay12 {
  animation-name: fade-in;
  animation-delay: 1.65s;
}
